// extracted by mini-css-extract-plugin
module.exports = {"page":"demo_page__1CnNR","loader":"demo_loader__2JQvQ","video":"demo_video__11kcj"};